
import React, { useEffect, useState } from "react";
import Select from "react-select";
import {
  createMuiTheme,
} from "@mui/material";
import { getUserData } from "../Api/homeapi";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { getUser_phoneDetails } from "../Api/firebaseAPis";
import { updateUserDetails } from "../Api/data";

function AdditionalDetails({comeFrom='normal',setIsModalOpen=false}) {
  const [firstname, setFirstname] = useState();
  const [lastname, setLastname] = useState();
  const [username, setUsername] = useState();
  const [gender, setGender] = useState("");
  const [dob, setDOB] = useState();

  const theme = createMuiTheme({
    palette: {
      type: "dark",
    },
  });
  const customStyles = {
    control: (base, state) => ({
      ...base,
      background: "#141414",
      text: "#fff",
      font: "#fff",
      color: "#fff",
      // match with the menu
      borderRadius: state.isFocused ? "3px 3px 0 0" : 3,
      // Overwrittes the different states of border
      borderColor: state.isFocused ? "grey" : "grey",
      // Removes weird border around container
      boxShadow: state.isFocused ? null : null,
      "&:hover": {
        // Overwrittes the different states of border
        borderColor: state.isFocused ? "grey" : "grey",
      },
    }),
    menu: (base) => ({
      ...base,
      background: "#141414",
      borderRadius: 0,
      // kill the gap
      padding: 10,
      marginTop: 0,
      text: "#EAEAEA",
      font: "#EAEAEA",
      color: "#EAEAEA",
    }),
    menuList: (base) => ({
      ...base,
      background: "#141414",
      text: "#fff",
      padding: 0,
    }),
  };
  const navigate = useNavigate();

  const getuserdata = async () => {
    const uid = localStorage.getItem("uid");
    const uData = await getUserData(uid);  
    if(uData.username && uData.firstname && uData.lastname && uData.dob && uData.gender){
      if(comeFrom==='event'){
        setIsModalOpen(false)
      }else{
        navigate('/home')
      }
     
    } 
    
  };

  useEffect(() => {
    getuserdata();
  }, []);



  const updateData = async () => {
    if (firstname && lastname && username && dob && gender) {
      const uid = localStorage.getItem("uid");
      console.log("Before updating", uid, username)
      let obj = {
        firstname: firstname,
        lastname: lastname,
        username: username,
        gender: gender,
        token: uid,
        dob: dob,
      };    
      const result = await updateUserDetails(obj, uid);  
    }
  };

  const accept_button = async () => {
    await updateData(); 
    
    setTimeout(() => {
      if(comeFrom==='event'){
        setIsModalOpen(false)
      }else{
        navigate('/home')
      }
    
    }, 0);   
  };

  return (
    <div className="container mx-auto shadow-lg">
      <div className="row profile_img_cont">
        <img
          src={window.location.origin + "/icon.jpg"}
          className="profile-image"
        />
      </div>
      <div className="seperator"></div>
      <div className="data_cont">
          <div className="data-row">
            <h4>First Name</h4>
            <input
              className="input-field"
              placeholder="Enter your first name"
              value={firstname}
              onChange={(e) => {
                setFirstname(e.target.value);
              }}
            />
          </div>
      
         
          <div className="data-row">
            <h4>Last Name</h4>
         
            <input
              className="input-field"
              placeholder="Enter your last name"
              value={lastname}
              onChange={(e) => {
                setLastname(e.target.value);
              }}
            />
          </div>
       

      
          <div className="data-row">
            <h4 className="my-2">Username</h4>
            <input
              className="input-field"
              placeholder="Enter your username"
              value={username}
              onChange={(e) => {
                setUsername(e.target.value);
              }}
            />
          </div>
    
     
          <div className="data-row">
            <h4>Date of Birth</h4>
           <input className="p-3 text-white bg-[#141414] outline-none border my-2 rounded-lg border-white "  type="date" value={dob} onChange={(e)=>setDOB(e.target.value)} placeholder="dd/mm/yyyy"/>
          </div>
     
         
          <div className="data-row">
            <h4 className="my-2">Gender</h4>
            <Select
              options={[
                {
                  label: "Male",
                  value: "Male",
                },
                {
                  label: "Female",
                  value: "Female",
                },
                {
                  label: "Other",
                  value: "Other",
                },
              ]}
              onChange={(opt) => {
                setGender(opt.value);
              }}
              styles={customStyles}
              theme={(theme) => ({
                ...theme,
                borderRadius: 0,
                colors: {
                  ...theme.colors,
                  text: "#fff",
                  font: "#fff",
                  primary25: "#141414",
                  primary: "#141414",
                  neutral80: "black",
                  color: "#fff",
                },
              })}
            />
          </div>
        

        <div
          onClick={() => {
            accept_button();
          }}
          className="row"
          style={{ justifyContent: "center", marginTop: 40 }}
        >
          <div className="gradientButton">
            <p
            className="text-center mb-0  pb-0 cursor-pointer font-semibold"
             
            >
              Apply Changes
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default AdditionalDetails;
